import React, { useCallback, useContext } from "react";
import { CondimentCardStyled } from "./CondimentCardStyled";
import { CondimentCardProps } from "../../../entities/Condiment";
import Button from "../../../UI/Button";
import { onOpenModal } from "../../Modal/slice/ModalSlice";
import { useAppDispatch } from "../../../store/store";
import { MODAL_TYPES } from "../../../entities/Modal";
import { toggleCondiment } from "../CondimentSlice";
import { TranslationContextInterface } from "../../../entities/Language";
import { TranslationContext } from "../../../context/TranslationContext";
import { getValueForKey } from "../../../context/translationsUtils";
import { TEST_ID } from "../../../shared/testid";
import ImageComponent from "../../../UI/ImageComponent";
import { useSelector } from "react-redux";
import { getTenantCredentials } from "../../Tenant/selectors";

const CondimentCard: React.FC<CondimentCardProps> = ({
  condiment,
  onSelect,
  view,
  isCategoriesCondiments = false,
  disableSelected = true,
}: CondimentCardProps) => {
  const credentials = useSelector(getTenantCredentials);
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const dispatch = useAppDispatch();

  const {
    id,
    image,
    name,
    description,
    botanicalOrigins,
    botanicalFamilies,
    latinNames,
    recommendation,
    history,
    meta,
  } = condiment;

  const onHandleMore = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    dispatch(
      onOpenModal({
        modalType: MODAL_TYPES.PRODUCT_PREVIEW,
        content: {
          id,
          name,
          image,
          description,
          botanicalOrigins,
          botanicalFamilies,
          recommendation,
          latinNames,
          history,
          type: "condiment",
        },
      }),
    );
  };

  const selectCondiment = useCallback(
    (condimentId: number) => {
      if (onSelect) {
        onSelect(condimentId);
      } else {
        if (disableSelected || meta.selected) {
          dispatch(toggleCondiment({ id: condimentId }));
        }
      }
    },
    [disableSelected, dispatch, meta.selected, onSelect],
  );

  const viewClass = `view-${view}`;
  const condimentTypeClass = `condiment-${
    isCategoriesCondiments ? "category" : "simple"
  }`;
  const selectedClass = meta.selected ? "selected" : "not-selected";
  const disableSelectedClass = meta.selected ? false : !disableSelected;

  const cardClassName = `${viewClass} ${condimentTypeClass} ${selectedClass} ${disableSelectedClass}`;

  return (
    <CondimentCardStyled
      className={cardClassName}
      data-hide={meta.hidden ?? false}
      onClick={() => selectCondiment(id)}
      data-testid={`${TEST_ID.CONDIMENT.CARD}-${condiment.id}`}
      $colorSelected={credentials?.webshopDesigns?.at(0)?.colorItemHover}
    >
      <div className="condiment-card__left">
        <div className="condiment-card__image">
          <ImageComponent url={image} name={name} />
        </div>
      </div>
      <div className="condiment-card__right">
        <div className="condiment-card__name">{name}</div>
        <div className="condiment-card__description">{description}</div>
        <div
          className="condiment-card__more"
          data-testid={TEST_ID.CONDIMENT.MORE}
        >
          <Button
            name={getValueForKey(translations, "default.more_button")}
            className="condiment-btn full-btn"
            bgColor={meta.selected?credentials?.webshopDesigns?.at(0)?.colorHoverButtonMore:credentials?.webshopDesigns?.at(0)?.colorButtonMore}
            onClick={(e) => onHandleMore(e)}
          />
        </div>
      </div>
    </CondimentCardStyled>
  );
};

export default CondimentCard;
